import route from './route'
import user from './user'

const routes = [
  ...route,
  ...user,
  {
    path: '*',
    redirect: {
      path: '/404',
    },
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/base/404'),
  },
  {
    path: '/demo',
    name: 'demo',
    meta: {
      title: process.APP.TITLE,
    },
    component: () => import(/* webpackChunkName: "home" */ '@/views/demo.vue'),
  },
]

export default routes
